import {DesignCollection} from '../../../stores/DesignCollection';
import {ColumnsDesignField} from './ColumnsDesignField';

export class ColumnsDesignCollection extends DesignCollection {
    insertFields(parentField, children) {
        this.fields.clear();
        children.forEach((f, idx) => {
            if (idx === 0) {
                f.cover = true;
            } else if (f.cover) {
                this.fields[0].setCover(false);
            }
            const newField = new ColumnsDesignField(f, parentField);
            newField.setCollection(f);
            this.fields.push(newField);
        });
    }
}
